import React from "react";
import DefaultLayout from "../layouts/Default";
import Slider from "../utils/Slider";
import Image from "../utils/Image";
import TitleCar from "../utils/TitleCar";
import LinkGeneral from "../utils/LinkGeneral";

const images = require.context("../../assets/img/", true);

const MainBanner = () => {
  const sliders = [
    { imageURL: "./banner1.png" },
    { imageURL: "./banner1.png" },
  ];

  return (
    <Slider
      data={sliders.map((item, index) => (
        <Image
          key={index}
          src={images(item.imageURL)}
          alt={`Banner #${index + 1} de la pagina web`}
          classNameDiv="p-0"
          classNameImg="w-100"
        ></Image>
      ))}
      id="slider-banner"
      classItems="w-100"
    />
  );
};

const FormulaCar = () => {
  return (
    <DefaultLayout>
      {/* <MainBanner /> */}
      <div className="row justify-content-center ">
        <div className="row col-11 col-lg-9 my-4">
          <div className="col-12 py-3">
            <TitleCar>
              <b>Formula CAR</b>
            </TitleCar>
            <div className="pt-5 pb-3 fs-responsive-m">
              <p>
                <b>FormulaCAR: </b> es una herramienta web que permite el
                registro de la información en un orden lógico para la
                formulación y evaluación de un proyecto; el sustento conceptual
                se basa en la metodología de Marco Lógico derivada de los
                procedimientos e instrumentos de la Planificación Orientada a
                Objetivos, y de esta manera se trabajan los principios de
                preparación y evaluación económica de los proyectos. A través de
                este sistema se deben utilizar y aplicar los conceptos básicos
                de la teoría de proyectos con el fin de validar posteriormente
                su viabilidad técnica y financiera.
              </p>
              <p>Ingresa aquí:</p>

              <LinkGeneral href="https://formula.car.gov.co">
                <div className="d-flex justify-content-center border rounded ">
                  <b>Formula CAR</b>
                </div>
              </LinkGeneral>
            </div>
          </div>
        </div>
      </div>
    </DefaultLayout>
  );
};

export default FormulaCar;
